/**
 * @fileoverview Shared user roles and statuses for KaraoNow.
 * @summary Centralized user roles and account statuses for both backend and frontend.
 *
 * @package @karaonow/shared
 * @module constants/user
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */
/**
 * @summary User role enumeration.
 * @type {enum}
 */
export var UserRole;
(function (UserRole) {
    UserRole["SUPERADMIN"] = "superadmin";
    UserRole["ORGANIZER"] = "organizer";
    UserRole["SINGER"] = "singer";
})(UserRole || (UserRole = {}));
/**
 * @summary User account status enumeration.
 * @type {enum}
 */
export var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "active";
    UserStatus["SUSPENDED"] = "suspended";
    UserStatus["DELETED"] = "deleted";
})(UserStatus || (UserStatus = {}));
/**
 * @summary Event status enumeration.
 * @type {enum}
 */
export var EventStatus;
(function (EventStatus) {
    EventStatus["DRAFT"] = "draft";
    EventStatus["ACTIVE"] = "active";
    EventStatus["COMPLETED"] = "completed";
    EventStatus["CANCELLED"] = "cancelled";
})(EventStatus || (EventStatus = {}));
/**
 * @summary Song queue item status enumeration.
 * @type {enum}
 */
export var QueueStatus;
(function (QueueStatus) {
    QueueStatus["PENDING"] = "pending";
    QueueStatus["CURRENT"] = "current";
    QueueStatus["COMPLETED"] = "completed";
    QueueStatus["CANCELLED"] = "cancelled";
})(QueueStatus || (QueueStatus = {}));
/**
 * @summary Check if a role is a valid user role.
 * @param {string} role - The role to check.
 * @returns {boolean} True if the role is valid, false otherwise.
 */
export function isValidUserRole(role) {
    return Object.values(UserRole).includes(role);
}
/**
 * @summary Check if a status is a valid user status.
 * @param {string} status - The status to check.
 * @returns {boolean} True if the status is valid, false otherwise.
 */
export function isValidUserStatus(status) {
    return Object.values(UserStatus).includes(status);
}
/**
 * @summary Check if a status is a valid event status.
 * @param {string} status - The status to check.
 * @returns {boolean} True if the status is valid, false otherwise.
 */
export function isValidEventStatus(status) {
    return Object.values(EventStatus).includes(status);
}
/**
 * @summary Check if a status is a valid queue status.
 * @param {string} status - The status to check.
 * @returns {boolean} True if the status is valid, false otherwise.
 */
export function isValidQueueStatus(status) {
    return Object.values(QueueStatus).includes(status);
}
//# sourceMappingURL=user.js.map